module.exports = __webpack_public_path__ + "static/wktl-logo-2022-13ee5ff6992d061e72669315f31aab17.png";